import React from "react"

type Props = {
    id: string
    name: string
    value: string
    isChecked: boolean
    onChange: () => void
    message: string
    description: string
}

const SectionSettingCheckbox = (props: Props) => {
    return (
        <div className="row">
            <div className="col-2"/>
            <div className="col-10">
                <div className="custom-control custom-checkbox">
                    <input
                        className="custom-control-input"
                        type="checkbox"
                        id={props.id}
                        name={props.name}
                        value={props.value}
                        checked={props.isChecked}
                        onChange={props.onChange}
                    />
                    <label className="custom-control-label" htmlFor={props.name}>{props.message}</label>
                    <small className="form-text text-muted">{props.description}</small>
                </div>
            </div>
        </div>
    )
}

export default SectionSettingCheckbox


// WEBPACK FOOTER //
// ./src/template/sections/content/common/InputCheckboxComponent.tsx